module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "part01"
    }
  }), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "part-number"
  }, [_vm._v("PART ONE")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "extra-indent",
    attrs: {
      "id": "part_p1"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "extra-indent",
    attrs: {
      "id": "part_p2"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "body-text1",
    attrs: {
      "id": "part_p3"
    }
  }, [_vm._v("Up here, the music was just a throbbing under the feet, a distant pulse. Down below, down through the roof, through and beneath the offices, down in the amphitheater shaped like a soup bowl, the crowd was roaring and pounding and yelling down at the four musicians in the bottom of the bowl. The musicians scooped up the roars coming in at them, pushed them through electric guitars and amplifiers, and sent back howls of sound that dwarfed the noise of the crowd, till the roaring was like a blast of heat on the face. But up here it was no more than a continuing throb in the gravelly surface of the roof.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p4"
    }
  }, [_vm._v("Parker raised the ax over his head and swung it hard down into the tarred surface of the roof. "), _c('i', [_vm._v("Thop")]), _vm._v(" went the ax. Parker and the two men beside him heard clearly the sound of the ax, but even as close by as the man on lookout at the fire escape, the sound was lost.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p5"
    }
  }, [_vm._v("“That’ll take all night,” Keegan said, but Keegan \n"), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("\nwas a nay-sayer and no one ever listened to him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p6"
    }
  }, [_vm._v("Parker lifted the ax again, swung it again, twisted it slightly as it struck, and this time a touch of more amber color showed through the tar and gravel: wood.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p7"
    }
  }, [_vm._v("Parker moved to the left, so his next slice would be across the first two, and lifted the ax again. He was a big man, blocky and wide, with heavy hands roped across the backs with veins. His head was square, ears flat to the skull, hair thin and black. His face had a bony rough-cut look, as though the sculptor hadn’t come back to do the final detail work. He was wearing black sneakers, black permanent-press slacks, and a black zippered nylon jacket; the jacket was reversible, light blue on the other side, and under it he was wearing a white shirt and a blue-and-gold tie. Cheap brown cotton work gloves were on his hands, and on the hands of the other three.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p8"
    }
  }, [_vm._v("It was spring, a dry but cloudy night, the temperature in the low fifties. It was ten minutes past midnight; down below, the Saturday midnight show was building toward crescendo. The final show at the old Civic Auditorium. Monday the wreckers would arrive. From up here on the roof, the poured-concrete flying-saucer shape of the new auditorium could be seen on Urban Renewal-cleared land half a dozen blocks away.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p9"
    }
  }, [_vm._v("Keegan said, “I don’t like it up here.” A stocky man, just under average height, Keegan had thick dry brown hair and the outraged expression of a barroom arguer. He, too, was dressed in dark clothing; he kept forgetting about the gloves on his hands, starting to put his hands in his pockets—each time he would suddenly remember, look startled, and then shake his head in irritation with himself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p10"
    }
  }, [_vm._v("Each time Parker swung the ax now, more wood \n"), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("\nshowed. There was over an inch of tarpaper and tar and stones on top of the wood, and the ax blade was getting streaked black with tar. After half a dozen swings with the ax, Parker had exposed a chopped-up section of wood about the size and shape of a footprint. After his seventh swing, Briley said, “Let me have a whack at it,” and Parker handed over the ax and stepped back out of the way.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p11"
    }
  }, [_vm._v("Briley was tall, but lean, and spoke with the hill accent of Tennessee. His face was deeply lined, more than it should have been in a man his age, and the lines were black, as though they’d been drawn on with charcoal. Briley had been two things earlier in his life—fat and a miner—but since the nine days he’d spent underground after a cave-in, he’d been neither. He swung the ax now hard and mean, as though it were Appalachia he was chopping.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p12"
    }
  }, [_vm._v("Parker stood and watched, his hands dangling loose at his sides. When in motion, he looked tough and determined and fast, but when waiting, when at rest, he looked inert and lifeless.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p13"
    }
  }, [_vm._v("Keegan went over to talk to Morris, the man sitting on the low wall at the edge of the roof, his arm carelessly draped over the curving top rail of the fire escape. Parker could hear the querulous sound of Keegan’s voice, but not the words. Morris, a young, soft-looking man with slumped shoulders, was also their driver. His quiet nondescript voice filled the small spaces left by Keegan’s. Morris had the calm and even temper of a man who doesn’t care about anything. He was a pothead, and he’d dabbled in the harder drugs, but not while working; Parker had made sure of that ahead of time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p14"
    }
  }, [_vm._v("Briley made a dozen fast mean slashes at the roof with the ax, extending the area of the chopped-up exposed wood to about the size of a mess-hall tin, and then Parker \n"), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v("\ncalled, “Keegan, come take your turn.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p15"
    }
  }, [_vm._v("“I’m coming.” Even that sounded querulous.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p16"
    }
  }, [_vm._v("Morris sat up straighter on the wall and called, “You want me to take a turn?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p18"
    }
  }, [_vm._v("“You just keep an eye down below.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p19"
    }
  }, [_vm._v("“Somebody else could watch for me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p20"
    }
  }, [_vm._v("“It’s better to keep one man on watch,” Parker said, and turned his back so Morris wouldn’t argue any more. He’d learned long ago that in dealing with men, it was always best to curb impatience and give them explanations, but he’d also learned that explanations could go on forever if they weren’t cut off.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p21"
    }
  }, [_vm._v("Briley took one more hack at the roof, then reluctantly turned over the ax to Keegan. Stepping back, grinning, wiping his forehead with the back of one hand, Briley said, “That’s a good workout.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p22"
    }
  }, [_vm._v("Keegan hesitated a minute, holding the ax across his body at thigh-height with both hands, making sure he had his feet set right. But he swung hard and clean, and he knew to twist the handle as the blade went in.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p23"
    }
  }, [_vm._v("After the first stroke, he said, “We’ll be at this till morning.” The next swing, the ax blade sank on through the wood and almost knocked him off-balance.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p24"
    }
  }, [_vm._v("“Hold it,” Parker said. Keegan pulled the ax out and stood back watching, and Parker went down on one knee beside the hole. He took off his right glove and picked away some splinters of wood, then felt around underneath with the tips of his fingers. Nodding, he got to his feet again and said, “There’s a space under. Chop the hole a little bigger, but don’t go straight down. We don’t know about wiring.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p25"
    }
  }, [_vm._v("Keegan bent over the hole, gripping the ax near the blade with his right hand and halfway down the handle \n"), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v("\nwith his left. Using short chops, he sliced away at the gouged wood, opening a hole the size of a coffee-container lid, then stopping.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p27"
    }
  }, [_vm._v("“Bigger than that,” Parker said. “We’ve got to be able to see in there.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p28"
    }
  }, [_vm._v("“I think I’m hitting a two-by-twelve here on the right. I’ll go the other way.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p29"
    }
  }, [_vm._v("The other three watched him, and Keegan bent low over his work, chopping six inches from his feet. He opened a hole as big around as a guard’s hat, and then stepped back again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p30"
    }
  }, [_vm._v("“I’ll get the flashlight,” Briley said. There were two metal toolkits on the roof out of the way, and Briley went to them and opened the one on the left.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p31"
    }
  }, [_vm._v("Parker went down on one knee again, picked away the splinters from around the edge of the hole, and when Briley brought him the flashlight he bent low over the hole to shield the light while he looked inside.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p32"
    }
  }, [_vm._v("The tar had been laid down on tarpaper, which had been tacked to wooden planks. The planks, Parker now saw, had been laid across two-by-twelve joists sixteen inches apart. A ceiling of planks was fastened across the underpart of the joists, closing this space off. There was neither electric wiring nor insulation anywhere to be seen.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p33"
    }
  }, [_vm._v("Parker switched off the flashlight and got to his feet. “I think we’ve got an extra level to go through.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p34"
    }
  }, [_vm._v("“There’s always some damn thing,” Keegan said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p35"
    }
  }, [_vm._v("“I can use the workout,” Briley said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p36"
    }
  }, [_vm._v("Parker took the ax and took full swings, clearing the tar out of a wider area, bounded by the joists underneath. Keegan went back over to complain to Morris some more, but Briley stood impatiently waiting for Parker to be finished with his turn at the ax.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p37"
    }
  }, [_vm._v("Briley ended the job at this level, swiping the ax down sideways, as though playing golf, stripping wood away even with the joist-edge on both sides. Then he and Parker pulled all the shards and splinters out of the hole.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p38"
    }
  }, [_vm._v("Briley said, “That wood’ll be nothing to punch out.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p39"
    }
  }, [_vm._v("“We don’t know what’s under it. Hold the light for me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p40"
    }
  }, [_vm._v("From the toolkits Parker got a hand drill and a narrow handsaw. He and Briley knelt across the hole from each other, and while Briley held the flashlight low, Parker drilled a hole in the planking near one of the joists, put the drill to one side, inserted the first few inches of the saw into the hole, and slowly sawed the one plank all the way across. Then Briley got a hammer and chisel, and while Parker held the light, he pried up one edge across the saw-mark. His hands around the edge of the plank, knees braced on the roof, Briley bent the plank upward and back until it cracked with a sound like a pistol shot in a barn.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p41"
    }
  }, [_vm._v("“Got you, you son of a bitch.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p42"
    }
  }, [_vm._v("Grinning, Briley twisted the plank back and forth till it ripped entirely free. Keegan had come back over by now, and the three of them looked down in when Parker shone the light through the new hole. They saw fluffy pinkness, like clouds: insulation. Also a length of old-fashioned metal-shielded electric cable.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p43"
    }
  }, [_vm._v("Keegan said, “Now where do you suppose the box is?” Electricity was his department.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p44"
    }
  }, [_vm._v("Parker said, “We’ll have to assume it’s live.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p45"
    }
  }, [_vm._v("Briley said, “At least the saw won’t cut through it. I saw a boy do that once with the new wire.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p46"
    }
  }, [_vm._v("“It wouldn’t hurt him,” Keegan said. “Your saw handles are wood.”")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p47"
    }
  }, [_vm._v("Briley demonstrated with hand gestures, saying, “He had his left hand on the top of the saw for more pressure.” He grinned and said, “There’s a boy burned for his sins.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p48"
    }
  }, [_vm._v("“Kill him?” Keegan sounded really interested.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p49"
    }
  }, [_vm._v("“No. Threw him about twelve foot.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p50"
    }
  }, [_vm._v("Parker began to saw again. After a while he gave the saw to Keegan, and in the silence before Keegan started, the music could be heard, very faintly. But an actual presence now, and not merely a vibration.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p51"
    }
  }, [_vm._v("As each plank was sawn through, Briley gripped it, bent it up and back, and each one snapped near the opposite joist. When an area had been cleared about a foot square, Parker took a linoleum knife from one of the toolkits and used it to cut through the insulation, slicing across the same line over and over until he got down to the paper backing. He slit that across, reached his gloved fingers under, and ripped the insulation upward. It had been stapled to the joists on both sides, and came up in a series of quick jerks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p52"
    }
  }, [_vm._v("And underneath was sheetrock, which should be the ceiling of the room below. The surfaces, from top to bottom, were the tar and gravel on tarpaper on wood laid across joists set on wooden planks laid across more joists going in the opposite direction, against the bottom of which was the sheetrock. With the joists, vertical two-by-twelve beams, going one way in the top air space and the other way in the lower insulated airspace, that meant there would be no opening they could make larger than fifteen inches square.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p53"
    }
  }, [_vm._v("It was twelve-thirty when Parker took the linoleum knife and began to score the sheetrock along the edge of one joist; they’d been at this twenty minutes. They’d \n"), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v("\nopened an area larger than they’d be able to use, and the electric cable was just outside the section they were working on.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p54"
    }
  }, [_vm._v("Parker scored the sheetrock three times down the same line, and the fourth time the knife broke through over the whole length. Briley was holding the flashlight again now; Parker dropped the knife on the sheetrock and got to his feet, saying to Keegan, “I did the left side.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p55"
    }
  }, [_vm._v("Keegan got down on his knees beside the hole. “Getting colder,” he commented, though it wasn’t, and went to work on the opposite side. When that was cut through, he scored a line bridging the cuts at one end, drew the knife down along that line again, and when he did it a third time, the whole section of sheetrock sagged downward.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p56"
    }
  }, [_vm._v("Parker had been standing across from Keegan, watching. Now he said, “We want to lift it up, if we can.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p57"
    }
  }, [_vm._v("Keegan looked up, squinting into darkness after looking into the flashlight’s illumination. “Why not just kick it through?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p58"
    }
  }, [_vm._v("“Noise.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p59"
    }
  }, [_vm._v("“Who’d hear anything with that racket? That’s the whole idea, isn’t it?” Every time they removed a layer of roof, the music and the crowd noises got louder. Now it was at about the level of a busy country bar on Saturday night, as heard from the driveway.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p60"
    }
  }, [_vm._v("“We don’t know if there’s a room under this one,” Parker said. “Or if anybody’s in it. They’d hear something that heavy hit the floor.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p61"
    }
  }, [_vm._v("“No problem, anyway,” Briley said, squatting down beside the hole. “Here, hold the flash, Keegan.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p62"
    }
  }, [_vm._v("Keegan took the flashlight, and Briley took the linoleum knife. He chipped away a little at the stationary part of the end-line, so there’d be room for his fingers, then \n"), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v("\nput the linoleum knife to one side, reached down to grasp the end of the sagging section of the sheetrock, and pulled it slowly upward. It curved, but wouldn’t split.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p64"
    }
  }, [_vm._v("Parker stood beside him and took one corner in both hands. “Get a better grip.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p65"
    }
  }, [_vm._v("“Thanks.” Briley, still holding the sheetrock, got to his feet and then shifted his hands to the other corner. “When you’re ready.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p66"
    }
  }, [_vm._v("They pulled upward, and the sheetrock cracked along the fourth side with a flat sound like two pool balls hitting. They leaned it back at an angle against the edge of the cleared section, like an open trapdoor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p67"
    }
  }, [_vm._v("Morris called, “Something happening down below.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p68"
    }
  }, [_vm._v("All three went over to look. They were about fifty feet from the ground, the equivalent of a six-story building. There were windows in the top two stories, but below that the wall was blank. Black metal doors led out to the fire escape on the top two landings. By day, the wall was made of grimy gray-tan bricks; by night, it was simply darkness, with an illuminated blacktop alley at the bottom. Down there, near the bottom of the fire escape, a pair of large black metal doors led inside somewhere; all equipment for the shows put on here came through the wrought-iron gates at the sidewalk end of the alley, down across the blacktop and through those metal doors. At the far end, the alley was stopped by a blank brick wall. The opposite side of the alley was the rear wall of the Strand, a shut-down movie theater. The Strand and the Civic Auditorium stood back to back at opposite ends of a long block, all of which would come down, starting Monday. A sixty-eight-story office building covering the whole block was due to go up, starting next year.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p69"
    }
  }, [_vm._v("Down below now, the wrought-iron gates over by \n"), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _vm._v("\nthe sidewalk were standing half-open, and someone was moving around with flashlights. Two of them, with two flashlights.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p70"
    }
  }, [_vm._v("“Now how the hell did they get onto us?” Keegan said. He didn’t sound surprised.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p71"
    }
  }, [_vm._v("“They’re not onto us,” Morris said. He was still sitting on the wall, half-twisted around, with his shoulder braced against the curving top rail of the fire escape as he looked down.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p72"
    }
  }, [_vm._v("“They’re cops, though,” Briley said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p73"
    }
  }, [_vm._v("“Looking for groupies,” Morris said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p74"
    }
  }, [_vm._v("Keegan turned an exasperated frown on Morris. Things he didn’t understand he liked even less than things he did understand. “Groupies? What the hell’s a groupie?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p75"
    }
  }, [_vm._v("“Rock-and-roll fan. Mostly girls.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p76"
    }
  }, [_vm._v("Briley laughed and said, “Looking for autographs?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p77"
    }
  }, [_vm._v("“Looking to get laid.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p78"
    }
  }, [_vm._v("A flashlight beam arched upward in their direction, and they all leaned backward. They waited a few seconds, and then Morris took a look and said, “They’re all done.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p79"
    }
  }, [_vm._v("“Just so they don’t come up the fire escape,” Keegan said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p80"
    }
  }, [_vm._v("Parker looked over the edge, and the flashlights were moving back toward the wrought-iron gates.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p81"
    }
  }, [_vm._v("Morris said, “Just an easy check. Now they’ll put a man outside the gates, so nobody climbs over.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p82"
    }
  }, [_vm._v("“By God,” said Keegan irritably, “what if they see something on the Strand door?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p83"
    }
  }, [_vm._v("They wouldn’t, because there was nothing to see, but nobody bothered to answer him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p84"
    }
  }, [_vm._v("They had gotten here through the Strand. At four-thirty"), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _vm._v(" this afternoon they’d driven up to the entrance of the Strand in a gray-and-white Union Electric Company truck, all four of them wearing gray one-piece coveralls with the company name in white on the back. It had been simple to get through the lobby doors of the Strand, carrying three toolkits, the third containing sandwiches and a Thermos container of coffee. Briley and Keegan and Morris had played blackjack to pass the time, betting the expected proceeds from this job, but Parker had slept for a while, walked around the dusty-smelling empty theater for a while, and sat for a while in darkness in the manager’s office, looking out at the city. He’d watched the crowds form for the early show, all the bright colors after the gray centuries of Reason, and then the traffic. Then he’d left the office to walk some more.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p85"
    }
  }, [_vm._v("He had a woman, named Claire, that he found himself thinking about while waiting. She was somewhere in the Northeast now, buying a house; the thought of having a woman who owned a house was a strange one. He’d been married once, to a woman named Lynn, but they’d lived in hotels; his life, and she’d adapted to it. She was dead now; she’d been hard, but pressure had come to her, and she’d broken. The new one, Claire, was not hard, but Parker thought she wouldn’t break.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p86"
    }
  }, [_vm._v("Morris said, “There they go,” and the wrought-iron gates closed, and there was no longer any light down there except the one yellow globe suspended from a metal pipe jutting out of the Civic Auditorium wall. “I doubt they’ll be back.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p87"
    }
  }, [_vm._v("Parker said, “Watch. Just in case.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p88"
    }
  }, [_vm._v("“Oh, I will.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p89"
    }
  }, [_vm._v("Parker and Briley and Keegan went back to the hole they’d made and squatted down on their haunches, \n"), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _vm._v("\nand Briley shone the flashlight down into the room below.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p90"
    }
  }, [_vm._v("So far, the map they’d bought had been absolutely right. Right about the Strand, the alley, the fire escape, the roof. And now, right about the room. They’d chopped where the map said to chop, and it had led them to an empty office. “Public Relations,” the map had told them; “already moved to temporary offices in another building.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p91"
    }
  }, [_vm._v("Sometimes jobs were done this way, from a map—a package, really, like a do-it-yourself radio kit—bought from a middleman who had bought it from someone on the inside, a non-professional who simply laid out the particulars of the case. Years before, most of John Dillinger’s jobs had been done that way, bought as a packet from a middleman, and it was still sometimes the best way to get set up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p92"
    }
  }, [_vm._v("The office below was just as the map had described: medium size, two desks, four chairs, a short brown Naugahyde sofa, several gray-metal filing cabinets. One of the desks, empty except for a green blotter, black telephone and one wrinkled legal-sized envelope, was directly beneath the hole.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p93"
    }
  }, [_vm._v("“Hold this,” Briley said. Parker took the flashlight from him, and Briley put both hands on one of the lower-level joists and dropped down into the room. He swung forward once, backward once, and dropped two feet to the desk top. He grinned up toward the flashlight and dropped lithely down to the gray carpet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p94"
    }
  }, [_vm._v("Behind each of the desks was a swivel chair; beside each desk was a straight armless wooden chair. Briley now picked up the nearest wooden chair and put it on top of the desk. “Join me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p95"
    }
  }, [_vm._v("Keegan went next, more awkwardly than Briley, having trouble at first finding his footing on the chair. Briley held the chair steady, but didn’t touch Keegan, who \n"), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _vm._v("\ngot his balance, released the joist over his head, held the chair back instead, and stepped down onto the desk. He sat down on the desk, put his feet over the side, and stood up on the floor, dusting white sheetrock powder from the seat of his pants.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p96"
    }
  }, [_vm._v("Parker called to Morris, “Going down now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p97"
    }
  }, [_vm._v("“Have a good time.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p98"
    }
  }, [_vm._v("Parker dropped the flashlight to Briley, who lit his way. He dropped to the chair, jumped to the desk, then to the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p99"
    }
  }, [_vm._v("“This is the worst time,” Keegan said. “Right now. What would we do if that door opened and a lot of cops came in?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p100"
    }
  }, [_vm._v("Neither of the other two said anything. Keegan had lost over four hundred dollars he didn’t have yet in the blackjack game: two hundred fifty to Briley, the rest to Morris. It had made him more pessimistic and irritable than usual.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p101"
    }
  }, [_vm._v("This room had a window, but it opened on a narrow airshaft that came up the middle of the building. The top of the airshaft had been their landmark on the roof. Since the door was solid wood, there was no reason not to turn the light on. Briley went over and flicked the wall switch by the door, and put away the flashlight. He said, “Now we make our stairway. To paradise, huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p102"
    }
  }, [_vm._v("“Listen to that music,” Keegan said peevishly. “What the hell ever happened to jazz?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p103"
    }
  }, [_vm._v("“It’s still there,” Briley said, going over to the filing cabinets, “in the same gin mills it always was. When did jazz ever play a joint like this?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p104"
    }
  }, [_vm._v("“Jazz at the Phil,” Keegan said. “I used to have all those records, before that time I got sent up.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p105"
    }
  }, [_vm._v("“Jazz at the Phil,” Briley said scornfully. “Fake.” \n"), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _vm._v("\nHe opened a file drawer. “Empty! There’s a break.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p106"
    }
  }, [_vm._v("“What do you mean, fake? All the greats were on "), _c('i', [_vm._v("Jazz at the Phil.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p107"
    }
  }, [_vm._v("“Okay,” Briley said. “Give us a hand here, will you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p108"
    }
  }, [_vm._v("Keegan went over to help him move the filing cabinet. “I don’t know how you can call them a fake. My God! Lester Hawkins, Dizzy Gillespie, Johnny Hodges—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p109"
    }
  }, [_vm._v("“I guess you’re right,” Briley said, grinning. “I must of been thinking of something else.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p110"
    }
  }, [_vm._v("Parker had taken the chair down off the desk, and now stood at one end of it. Briley and Keegan put the filing cabinet down, picked up the other end of the desk, and the three of them moved it over till it was no longer directly beneath the hole. Then Briley and Keegan moved the filing cabinet to abut against the edge of the desk closest to the hole, while Parker put the chair back up on top of the desk again. They kept moving furniture, and when they were done they had a complicated stairway leading up toward the hole, and facing the doorway. A man coming in the doorway would have two or three strides into the room, then a foot-high step to an upended metal wastebasket, then a step a foot and a half high to the desk, another foot and a half up to the wooden chair, a foot to the top of three filing cabinets lined up in a row, and finally a foot and a half to the second wooden chair, on top of the filing cabinets. This put one six and a half feet above the floor, where the top of the roof came to about waist-level; an easy climb. This kind of stairway was better in two ways than any kind of rope ladder or anything of that sort they might have brought with them; first, because it meant one less thing they had to carry to the job, and second, \n"), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _vm._v("\nbecause it could be gone up faster than any kind of portable ladder.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p111"
    }
  }, [_vm._v("Briley now went up their staircase and out onto the roof, and Parker went partway up after him. Briley handed down the toolkits one at a time to Parker, who handed them down to Keegan. Briley said something to Morris, waved, and came back down into the room.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p112"
    }
  }, [_vm._v("Keegan had already opened the other toolkit. The three masks he removed from it were made of black cotton and covered the entire head, with openings for eyes and mouth. The three handguns were all Smith & Wesson Model .39’s, a 9mm Luger automatic with an eight-shot clip. There were also three small blue packets: blue plastic laundry bags, costing a nickel each from a laundromat vending machine.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p113"
    }
  }, [_vm._v("They put on the masks and checked their guns and stowed the little laundry-bag packages in their pockets. Then Parker nodded to Briley, who flicked off the light switch and in darkness opened the door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p114"
    }
  }, [_vm._v("There was some light in the hall outside, not much. But much more noise. Whenever the music ended, the crowd noise increased to a kind of ecstatic scream, fading as the music started up again, but gradually building through the next number till music and crowd seemed about equally matched by the end of the tune, when there would be another concerted scream.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p115"
    }
  }, [_vm._v("It was five past one; they’d been working fifty-five minutes since Parker first swung the ax into the roof.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p116"
    }
  }, [_vm._v("Parker was the first into the hall, looking to the right and left. Doors on both sides of the hall in both directions, mostly closed, a few standing open. No lights burning up at this level at all. Far down to the right a stairwell, with light shining up, reflecting off the pale \n\n"), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _vm._v("\ngreen corridor walls, giving light to see by down here.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p117"
    }
  }, [_vm._v("Parker turned right, and the other two followed, Briley turning the doorknob to be sure the lock wasn’t on, then shutting the door behind them. Keegan carried the one toolkit they still needed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p118"
    }
  }, [_vm._v("The flooring was some sort of composition, similar to linoleum; the sneakers they wore made no sounds against it. They walked slowly, leaning slightly forward, their right hands holding the automatics ahead of them and out away from their bodies.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p119"
    }
  }, [_vm._v("If Morris saw trouble coming now, they were past the point where they could retrace their steps. Morris’s job would be to come in after them and let them know their primary exit was blocked; they had a second exit route planned for, and a third.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p120"
    }
  }, [_vm._v("The noise was coming up the stairwell almost undiluted by distance. Standing at the top, looking over the rail and down at six flights of brightly lit empty silent metal stairs, hearing the rush of sound coming up there and yet not seeing any living person, you could begin to stop hearing the music as music, but simply as noise. Then it became the workings of some gigantic machine in a pit in the earth, and men who went down into it were chewed and ground and mangled.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p121"
    }
  }, [_vm._v("“Jesus,” Keegan said. Looking out the eyeholes of the mask, his eyes looked frightened; not by the job they were here to do, but by the noise that was supposed to cover them while they did it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p122"
    }
  }, [_vm._v("Parker started down the stairs. Briley came second, and Keegan third.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p123"
    }
  }, [_vm._v("The walls were plaster, and painted pale green. The stairs had a landing and a U-turn halfway down every flight. At the top floor the stairs had been open, but at the \n\n"), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _vm._v("\nnext level down there was a wall, with a green metal fire door. A darker green than the walls. The door was closed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p124"
    }
  }, [_vm._v("Parker put his hand on the knob and waited for the other two to come down to him. Then, quickly, he opened the door and stepped through.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p125"
    }
  }, [_vm._v("One of the notes with the map had said: “One private guard in the hall—armed—always watches show.” He was there, he was watching the show, he never saw Parker and the other two come in at all.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p126"
    }
  }, [_vm._v("On this floor, there were offices along one side of the corridor only, opposite the stairwell entrance. The other side of the corridor had sections of plate glass at intervals, through which could be seen the main soup bowl of the auditorium. The ceiling of the auditorium, barnacled with lighting equipment, was just above these plate-glass windows, giving the impression that one was viewing from above the auditorium rather than from within it—for the Caesar effect.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p127"
    }
  }, [_vm._v("It was at one of these windows that the guard was standing. A thin and potbellied man in his fifties, wearing a gray uniform with a gold circular patch on the sleeve, a wood-handled revolver in a holster high up toward the waist on his right side, he was standing there with his hands clasped behind him, head bent forward and down, face in a relaxed expression of blank attention, as though he were daydreaming under cover of the noise. With only space and the one sheet of glass in the way, the sound volume here was very loud, much louder even than in the stairwell.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p128"
    }
  }, [_vm._v("Parker walked down the corridor toward the guard, Keegan to his left and Briley to his right, forming a triangle shape that filled the width of the hall. They were halfway from the stairwell entrance before their movement \n\n"), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _vm._v("\nattracted the guard’s attention; then he made a startled automatic move toward his revolver. But it was too high on his waist—he’d put it there for the comfort of his potbelly, no doubt—and a leather strap was snapped in place over the top of the holster to keep the revolver from falling out, and the three faceless men walking toward him all had guns already in their hands. And there was no furniture, no handy open doorway, no place to run, no cover to hide behind; nothing but the empty hallway. The guard, looking bitter and angry and disgusted, straightened from the half-crouch he’d naturally moved into, and slowly lifted his hands over his head.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p129"
    }
  }, [_vm._v("“Put them down,” Parker said. The guard didn’t make out the words through the noise, so Parker went closer and said again, “Put your hands down. Leave them at your sides. Now walk toward us.” When the guard was no longer in front of the glass, Parker said, “Now stop. Turn left. Put your hands on the wall in front of you at head-height. Lean forward. Touch your forehead to the wall.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p130"
    }
  }, [_vm._v("The guard managed as far as touching his hatbrim to the wall. Briley came forward and took the revolver out of the holster, having to use two hands to unsnap the leather strap. He put the revolver away in his hip pocket, and took his own automatic out again, then stepped back a pace.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p131"
    }
  }, [_vm._v("Parker said, “All right. Straighten up. Turn around. Good.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p132"
    }
  }, [_vm._v("Briley took the two-way radio from the guard’s left shirt pocket and backed up next to Parker again. The guard was looking more disgusted by the second.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p133"
    }
  }, [_vm._v("Parker said, “What’s your name?”")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p134"
    }
  }, [_vm._v("The guard frowned at him, not understanding the reason for the question, but he answered it: “Dockery.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p135"
    }
  }, [_vm._v("“First name.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p136"
    }
  }, [_vm._v("“Patrick.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p137"
    }
  }, [_vm._v("“Do they call you Patrick or Pat?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p138"
    }
  }, [_vm._v("“When it’s bums like you,” the guard said bitterly, “they call me Mr. Dockery.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p139"
    }
  }, [_vm._v("Briley, grinning, said, “Ah, Paddy Dockery, you talk mighty big when it’s three against one. You know you’re safe from us. I’d like to see you in a fair fight.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p140"
    }
  }, [_vm._v("Dockery gave him a brooding look. “You’ll laugh out of the other side of your face,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p141"
    }
  }, [_vm._v("“All right, Dockery,” Parker said. “Turn around. Walk slowly to the men’s room.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p142"
    }
  }, [_vm._v("The four of them made a small silent procession, out of phase with the beat of the music surrounding them. Dockery passed four doors on his left side, and turned toward the fifth, reaching his hand out to the knob.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p143"
    }
  }, [_vm._v("Parker said, “If you open that door, I’ll kill you and everybody the other side of it. I said the men’s room.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p144"
    }
  }, [_vm._v("Dockery’s hand hesitated, an inch from the knob. His shoulders were tensed to reject the bullet, but in the end he leaned back from the door and his hand dropped to his side. Not turning to look at Parker, he said, “It’s not my own life I was thinking of.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p145"
    }
  }, [_vm._v("“I know that,” Parker said. This was one of his specialties, as electricity was one of Keegan’s specialties and driving was one of Morris’s. Rare is the high-number robbery that isn’t cluttered up with people—bank customers or armored-car guards or store clerks or whatever. One of Parker’s specialties was handling the people, which meant keeping them quiet, making sure none of them got \n\n"), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _vm._v("\nkilled, making sure none of them loused up the routine. The last was the most important, and the others would be sacrificed to it, if necessary, though a neat job was always better.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p146"
    }
  }, [_vm._v("Parker was now handling the person called Patrick Dockery. Dockery was a proud and prickly man, and what he would be feeling now was mostly humiliation. He was the kind who would take almost any sort of damn-fool risk, would even throw his life away, to erase humiliation. He would open the wrong door, he might even turn and attack three armed men. He had to be handled until he’d been successfully maneuvered into the privacy of the men’s room, where he could be physically restrained. Out here in the hall, it meant giving him his respect back, easing his sense of humiliation. By letting him wise off, and by acknowledging that it really had been other people’s lives he’d been thinking of when he’d moved his hand back from that doorknob. Parker was treating his foolhardiness as though it were worthy of respect; if he had judged his man right, Dockery would respond by being good and doing what he was told.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p147"
    }
  }, [_vm._v("As he did. He led them now to the right room, and all four trooped inside, around the green metal wall divider just inside the door and into the main open green-tiled square of the room itself, where Parker said, “Take off the uniform.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p148"
    }
  }, [_vm._v("There was no way around this. The humiliation was harsh and blatant, but it was necessary.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p149"
    }
  }, [_vm._v("Dockery turned around, and there were pale circles of strain around his eyes. “You go to hell,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p150"
    }
  }, [_vm._v("“You aren’t going to stop us,” Parker told him. “Don’t make things tougher for yourself.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p151"
    }
  }, [_vm._v("Dockery glared a second longer, and then suddenly \n\n"), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _vm._v("\nran backward away from them, his head back and mouth open, shoving the first two fingers of his right hand down his throat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p152"
    }
  }, [_vm._v("“Damn it!” Briley jumped forward like a steeplechaser, swinging hard and fast with the automatic, the way he’d swung the ax earlier up on the roof. The barrel clipped Dockery on the forearm, near the wrist, and Dockery instinctively moved the arm, his hand no longer near his mouth. His hat had fallen off, and Briley kicked it to the side, then lunged forward, punching his shoulder into Dockery’s chest and running him backward the rest of the way into the wall, where he hit the side edge of a urinal, half-turned, and hit his left shoulder and the side of his head against the tile wall. Briley held him pinned there at arm’s length, his hand flat with splayed fingers on Dockery’s chest, as with the toe of his right shoe he started angrily kicking Dockery’s shins. “Son of a bitch,” he said, kicking at Dockery’s legs. “Stupid-ass son of a bitch.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p153"
    }
  }, [_vm._v("Parker came up beside them and said, “Stop that.” The music was down to a usable level again in here; he could talk in a normal tone of voice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p154"
    }
  }, [_vm._v("Briley stopped the kicking, but kept holding Dockery jammed against the wall. Turning his head, he complained, “He was gonna throw up on his uniform! I got to "), _c('i', [_vm._v("wear")]), _vm._v(" that uniform!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p155"
    }
  }, [_vm._v("“That was his idea,” Parker said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p156"
    }
  }, [_vm._v("“He thinks he’s smart.” Briley was panting and enraged. Glaring at Dockery through the eyeholes of his mask, he said, “Gonna screw up our plan, not let me wear the uniform. You know what kind of smart that is? That’s "), _c('i', [_vm._v("stupid")]), _vm._v(" smart!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p157"
    }
  }, [_vm._v("Parker leaned close to look at Dockery, who seemed dazed and winded and in pain. Parker said, “If you \n"), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _vm._v("\ncause us any more trouble, I don’t answer for what he’ll do to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p158"
    }
  }, [_vm._v("Dockery blinked at him, still mutinous. “I’ll remember you people.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p159"
    }
  }, [_vm._v("“That you will,” Briley said. He abruptly pulled his hand away from Dockery’s chest and stepped back a pace, and Dockery almost fell, but grabbed the urinal and held himself up till he got his balance back.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p160"
    }
  }, [_vm._v("“Take off your tie,” Parker said, and when Dockery didn’t move at once, Briley yelled, “Damn it, I’ll kick you into hamburger, I swear to God I will!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p161"
    }
  }, [_vm._v("Parker, still looking at Dockery, said to Briley, “That’s enough. He’ll do it. He wants to be in shape to identify us at the line-up.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p162"
    }
  }, [_vm._v("It was the right approach, at last. Dockery almost smiled, and there was less mutiny and more strength in his voice when he said, “And you’ll be there, don’t you worry. And I wouldn’t miss it for the world.” With a sudden angry gesture, as though it were an act of defiance, he reached up and yanked down on the knot of his tie, pulling the tie loose and flinging it with a contemptuous underhand flip toward Briley, who caught it in midair and said, “Do me a favor. Hang by your thumbs till we show up.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p163"
    }
  }, [_vm._v("Keegan, who had stayed over by the door in case anyone else should come in, the toolkit at the floor by his feet, now called, “What’s taking so long? We don’t have all night.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p164"
    }
  }, [_vm._v("“We’re ahead of schedule,” Parker called to him. They didn’t have that specific a schedule, but he didn’t want Dockery to get the idea he could fight them some more by moving very slowly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p165"
    }
  }, [_vm._v("As it was, Dockery was slow enough. Briley took each piece of clothing as it was tossed at him, and stood \n\n"), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _vm._v("\nthere with the parts of uniform over one arm. He wasn’t naturally a cruel man, and by the time Dockery got to his trousers Briley had cooled off and was no longer angry. Dockery had fresh jagged cuts on both shins, the skin around the cuts ragged like wrinkled onion-skin paper, droplets of blood oozing to the surface of the cuts. The trousers were the last, and when Briley had them he stood there a couple of seconds looking at Dockery’s legs, and then said, in a muted voice, “I’m sorry I did that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p166"
    }
  }, [_vm._v("“You will be,” Dockery said. His face was tight and unforgiving.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p167"
    }
  }, [_vm._v("“I got mad, is all,” Briley explained, apologizing again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p168"
    }
  }, [_vm._v("Dockery didn’t bother to answer that. He turned his head to look at Parker, accepting him as the leader and waiting to be told what to do next.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p169"
    }
  }, [_vm._v("Parker said, “Go over to the first stall.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p170"
    }
  }, [_vm._v("Dockery was in his underwear, socks, and shoes. Somehow he had more dignity now, not less. Out of the uniform, more of his own individuality was apparent; he looked less potbellied, and less ineffective. He seemed to sense the change in his appearance himself, and to behave accordingly; he strode over to the stall without fuss, without either defiance or defeat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p171"
    }
  }, [_vm._v("Briley had gone into another stall to change. Keegan came over to watch Dockery while Parker put his automatic away, took the handcuffs from his left hip pocket, got Dockery seated in the stall, and handcuffed his hands behind him, the cuff chain running under the pipe that came out of the wall about thirty inches from the ground. Dockery would be fairly comfortable there, but wouldn’t be able to get away.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p172"
    }
  }, [_vm._v("Parker stepped back out of the stall and was about \n\n"), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _vm._v("\nto pull the metal door shut when Dockery called, “Hey.” Parker looked at him, and Dockery said, “I don’t want any of you killed. I want you captured alive. I want to be able to testify against you, and I want to be able to see your faces. I want you to get sent up. I want to know that you’ll be getting years of what you gave me tonight.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p173"
    }
  }, [_vm._v("“It may happen,” Parker said, and shut the stall door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p174"
    }
  }, [_vm._v("Briley was coming out, in the uniform and without his mask. The pants were a little too short, and too big around the waist, but the shortness just made him look like an old man, and the gunbelt disguised the excess material at the waist.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p175"
    }
  }, [_vm._v("Briley’s taking the guard’s part was a last-minute change in the routine. An old man named Berridge had originally been set to do it. There’d been three meetings to set things up, and at the beginning of the third, Berridge had said, “There’s no point trying to lie to you boys. Or lie to me, either. I’ve lost my nerve. Maybe I’m too old, or I’ve had too much time inside, I don’t know. But I can feel inside my stomach I can’t do it.” Parker and the others had known better than to try to get a man to do what he felt he was incapable of doing—they’d be too dependent on one another during the job—but it was too late by then to get somebody to take Berridge’s place. This final Saturday night show before the Civic Auditorium was torn down was their only shot: a full house, all cash sales, no advance sales. Every dollar spent for a seat inside that jampacked soup bowl was still in this building, tonight only. So they’d altered the routine to go with a string of four instead of five, and the result was Briley in the guard’s uniform, grinning, self-conscious to be in the trappings of Authority.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p176"
    }
  }, [_vm._v("“How’s it look?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p177"
    }
  }, [_vm._v("“It’ll pass,” Parker said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p178"
    }
  }, [_vm._v("Keegan said, “The pants are too short.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p179"
    }
  }, [_vm._v("Briley looked at him. “You want me to send them out?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p180"
    }
  }, [_vm._v("“I only said.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p181"
    }
  }, [_vm._v("“You’ll do,” Parker said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p182"
    }
  }, [_vm._v("“The hat was too big,” Briley said. “I put some toilet paper around the brim.” He took the hat off, grinned at the inside, and put it back on. “I’ll go on out.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p183"
    }
  }, [_vm._v("Parker and Keegan waited half a minute, and then followed Briley out, Keegan carrying the toolkit again. They looked down to the right, and Briley was standing at the window, looking down at the musicians. There was no music right now, and the crowd noise was steadily dropping. Briley was standing in a good imitation of Dockery’s original position; stomach jutting out, head forward and down, hands clasped behind his back.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p184"
    }
  }, [_vm._v("Parker looked to his left, down through one of the windows at the platform in the middle of the auditorium. The four musicians who had been there were gone. Bulky stagehands in T-shirts and work pants, looking like citizens of a different planet from everybody else in the auditorium, were spreading a bright red carpet in the middle of the platform, moving the microphones and amplifiers around, and wheeling out a small keyboard instrument like a midget piano. In the middle of the red carpet was the white outline of a triangle, with an eye in it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p185"
    }
  }, [_vm._v("Keegan, beside Parker at the window, said, “They shouldn’t be able to get away with that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p186"
    }
  }, [_vm._v("Parker frowned at the platform, not knowing what Keegan was talking about, but didn’t ask.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p187"
    }
  }, [_vm._v("Keegan said, “That thing on the carpet there, that \n\n"), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _vm._v("\ntriangle. That’s off the dollar bill. That’s the kind of thing they do. Dress in the American flag, all that. None of them have any respect.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p188"
    }
  }, [_vm._v("Parker walked on to stand beside Briley, and Keegan followed. Briley, nodding at the platform, said, “The headliners are coming.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p189"
    }
  }, [_vm._v("According to Morris, the final group would play a minimum of twenty-five minutes. If they were feeling good, if they’d established an enjoyable rapport with the audience—Morris had said, “If the vibes are good”—they might extend that to an hour or more. But twenty-five minutes was the minimum, so that was the deadline.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p190"
    }
  }, [_vm._v("Parker looked at his watch: one twenty-five. He said, “We have to be out by ten to two.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p191"
    }
  }, [_vm._v("Keegan said, “Then we better move.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p192"
    }
  }, [_vm._v("“Let’s wait for more noise.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p193"
    }
  }, [_vm._v("It was almost quiet out there now, the crowd expectant and waiting. The stagehands finished their adjustments and waddled off, going back to the cigar butts they’d left on table edges. The audience noise tapered off even more, till individual coughs could be heard, and suddenly the auditorium lights went out, and they were looking down into darkness.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p194"
    }
  }, [_vm._v("Keegan was the only one who moved, making an abrupt jump to the left, past the edge of the window, the toolkit bumping his knee and the wall. Parker and Briley continued to stand there, side by side, looking down; Briley in the guard uniform, Parker in his dark jacket and the hood over his face. The corridor lights above and behind them remained on.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p195"
    }
  }, [_vm._v("Keegan said, “For Christ’s sake, they can see you!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p196"
    }
  }, [_vm._v("“A silhouette,” Parker said. “With the light behind me. Better they see a silhouette standing still than jumping away and trying to hide.”")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p197"
    }
  }, [_vm._v("“I got out of the way before they could see me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p198"
    }
  }, [_vm._v("The darkness wasn’t total down there. A sparse pattern of dull red exit lights glowed. Tiny red and green dots of light from the platform showed that the amplifiers were working; those dots seemed to wink all at once, meaning that people were moving around on the platform.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p199"
    }
  }, [_vm._v("The sound, when it came, had been anticipated for so long that it seemed unexpected, a surprise and a shock. An electronic crash, a chord of aggressive, whining, insistent notes blended into one detonation, an announcement of entry like the crash of an iron door back against an iron wall. An instant later one bright white beam flooded the platform from the ceiling, and there were now five musicians out there, one at the keyboard instrument, two with electric guitars, one at a complex array of drums, and one standing in the middle of the carpet’s triangle, holding a hand microphone; this last one was dressed completely in red, and when the light came on he opened his mouth wide, held the microphone against his lower teeth, and shrieked loud enough to make distortions in the loudspeakers. The audience shrieked back, the four instrumentalists began a heavy background beat that was most like the sound of a highballing freight train—a sound out of context, since it was unlikely anyone in this audience had ever ridden a train of any kind—and the one in red began to sing/shout into the microphone: "), _c('i', [_vm._v("“The-mes-sen-ger-of-Death-will-bring-you-down")]), _vm._v("…”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p200"
    }
  }, [_vm._v("Parker said, “It’s time.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p201"
    }
  }, [_vm._v("He and Keegan turned away from the window. Parker counted doors and went to the one he wanted. He turned the knob and walked in, and the man at the desk dropped his pen and cried, “Good God!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p202"
    }
  }, [_vm._v("“Take it easy,” Parker said. He took only one step into the room, then moved quickly to his left. Most of the \n\n"), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _vm._v("\nleft-hand wall was glass, and he didn’t want to be seen by anyone on the other side of it, not yet. For the same reason, Keegan stayed in the doorway.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p203"
    }
  }, [_vm._v("The man at the desk was about forty, very stocky in a soft-looking way. He wore horn-rim glasses, a dark gray suit, narrow tie, white shirt with button-down collar. He came from the same planet as the stagehands. He said, “I don’t have any money in here.” His voice was high-pitched and frightened; he might do something fatal simply out of nervousness.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p204"
    }
  }, [_vm._v("Parker said, his voice as low and calm as possible with the competition of the music, “We know that. We’re not after you, we’re not going to cause you any trouble.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p205"
    }
  }, [_vm._v("The man at the desk licked his lips, looking nervously at Keegan and then past Keegan toward the hall. “What did you do with the…what did you do with the man out there?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p206"
    }
  }, [_vm._v("“Mr. Dockery is perfectly all right. You’ll be all right, too. There’s nothing to worry about.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p207"
    }
  }, [_vm._v("Keegan came one step into the room, moved leftward to Parker’s side, put the toolkit down, shut the door. The man at the desk began to look more frightened again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p208"
    }
  }, [_vm._v("Parker said, “You’d be Mr. Stevenson, wouldn’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p209"
    }
  }, [_vm._v("“What? I—that’s right. Who are you people?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p210"
    }
  }, [_vm._v("“Ronald Stevenson?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p211"
    }
  }, [_vm._v("“I haven’t done anything to anybody. Why do you want—?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p212"
    }
  }, [_vm._v("“I told you we’re not after you. What do your friends call you? Ron? Ronnie?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p213"
    }
  }, [_vm._v("“My—I’m, uh—Most people call me RG.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p214"
    }
  }, [_vm._v("“RG. Well, this is a robbery, RG. We’re not here to hurt anybody or scare anybody. We’re just going to take \n\n"), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _vm._v("\nthe money. The management is insured against this kind of thing, so it’s nothing for anybody to get killed over. We’d prefer a nice quiet operation, and so would you. So up to a point our interests are the same.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p215"
    }
  }, [_vm._v("“But I don’t have any money.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p216"
    }
  }, [_vm._v("Keegan said, “Next door they have money.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p217"
    }
  }, [_vm._v("Stevenson looked at the glass wall facing his desk. The glass started at waist-height and continued up to within a foot of the ceiling. A three-foot width of ordinary wall was at this end, and a door with a glass panel in it was at the far end.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p218"
    }
  }, [_vm._v("Parker said, “Anybody looking at you, RG?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p219"
    }
  }, [_vm._v("“What?” Stevenson suddenly looked frightened again, and then guilty. “No, not at all.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p220"
    }
  }, [_vm._v("“Look down at the paper on your desk, RG. Good. Pick up your pen. Start to write.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p221"
    }
  }, [_vm._v("Looking down at his desk top, Stevenson said, “Write what?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p222"
    }
  }, [_vm._v("“Anything you want, RG. Just so the people next door see you looking normal.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p223"
    }
  }, [_vm._v("“Oh, I see.” Stevenson began to write. He didn’t really look normal, his shoulders were too hunched, the position of his head too tense, but a casual glance from the next room wouldn’t pick up that sort of detail.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p224"
    }
  }, [_vm._v("Parker gave him half a minute to calm himself, and then said, “Okay, RG, keep writing while I talk to you. There’s three guards next door. What’s the name of the one in charge?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p225"
    }
  }, [_vm._v("Still writing, looking down, Stevenson said, “That would be Lieutenant Garrison.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p226"
    }
  }, [_vm._v("“First name?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p227"
    }
  }, [_vm._v("“I believe—It’s Daniel, I believe.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p228"
    }
  }, [_vm._v("“Is he called Dan?”")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p229"
    }
  }, [_vm._v("Stevenson nodded at what he was writing. “I’ve heard him called Dan, yes.” He was a precise man by nature, and now he was using that precision as a means of self-defense, as though to say, If I am very accurate and very proper, nothing bad will happen to me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p230"
    }
  }, [_vm._v("It was an idea Parker wanted to encourage. “Good,” he said. “And the other two? What names?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p231"
    }
  }, [_vm._v("Stevenson glanced up, looking through the glass into the other room again, as though to refresh his memory, then quickly looked back down at the paper, went on writing, and said, “The younger one is Lavenstein, Edward Lavenstein. He’s called Beau. And the other one is Hal Pressbury.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p232"
    }
  }, [_vm._v("“Dan Garrison, Beau Lavenstein, Hal Pressbury.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p233"
    }
  }, [_vm._v("“Yes, that’s right.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p234"
    }
  }, [_vm._v("“Good. Keep writing, RG, this’ll take a minute.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p235"
    }
  }, [_vm._v("Stevenson kept writing, though his shoulders hunched again. Parker touched Keegan’s elbow, and Keegan nodded and went down on one knee beside the toolkit. Putting his automatic on the floor, he opened the toolkit and took out an automobile rear-view mirror; just the rectangular piece of silvered glass, without the metal housing or the mounting arm. Carrying the mirror, he traveled on all fours diagonally past Parker to the glass wall, staying under the bottom edge of the glass. When he got to the wall he switched to a sitting position, legs crossed tailor-fashion and head stooped somewhat, and slowly raised the mirror up in front of him. He was sitting sideways to the wall, and had the mirror turned at an angle; when it was a little above his head, he said, “Got’em.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p236"
    }
  }, [_vm._v("“What’s it look like?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p237"
    }
  }, [_vm._v("“Double room. Double length, I mean.” The mirror moved slightly. “Two doors to the hall, one near, one \n\n"), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _vm._v("\nfar. Sofa in between, one guard sitting at it. Table against the wall beyond the far door, one guard sitting in a chair at the table, facing the wall, playing solitaire.” The mirror moved. “Four desks down the middle of the room, with adding machines. Three men, one woman. Cash on all four desks. They’re counting it, banding it, dropping the stacks into metal trays on the floor. Back wall all filing cabinets, no door.” The mirror moved. “Right wall, four windows. Table between windows two and three, with canvas sacks on it, most of them empty. Here comes the woman.” Silence for ten seconds; the mirror moved. “The dough must have come upstairs in the sacks. She just took one of the full ones, carried it to the desk, emptied the bills out, put the empty sack back on the table. Now she’s gone back to work.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p238"
    }
  }, [_vm._v("“Where’s the third guard?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p239"
    }
  }, [_vm._v("“On the right.” The mirror moved. “Leaning against the wall beside the money table. Kind of looking around at everything.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p240"
    }
  }, [_vm._v("“That’ll be Garrison. RG, don’t look up. Keep writing. Is Garrison the one beside the money?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p241"
    }
  }, [_vm._v("“He was, yes, the last I looked.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p242"
    }
  }, [_vm._v("“The young one, Beau Lavenstein, is he the one playing solitaire?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p243"
    }
  }, [_vm._v("“Yes, he was.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p244"
    }
  }, [_vm._v("Parker nodded. That made Hal Pressbury the one on the sofa. Parker said to Keegan, “How many phones?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p245"
    }
  }, [_vm._v("The mirror moved. “One, on the first desk.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p246"
    }
  }, [_vm._v("“RG, if you were going to call that number, what would you dial?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p247"
    }
  }, [_vm._v("“That’s extension twenty-three.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p248"
    }
  }, [_vm._v("“Is that all you dial? Two three?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p249"
    }
  }, [_vm._v("“No. For an inside call, you dial nine first.”")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p250"
    }
  }, [_vm._v("“Nine two three, and that phone will ring?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p251"
    }
  }, [_vm._v("“That’s right, yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p252"
    }
  }, [_vm._v("“Good. Now, RG, I want you to do me a favor. I want you to get up and go to the filing cabinet behind you. Open the top drawer and act as though you’re looking for something. Good. Just like that. Stay there.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p253"
    }
  }, [_vm._v("Parker got down on hands and knees and crawled across the carpet and around behind the desk. Keegan kept watching the other room in the mirror, and Stevenson stood at the filing cabinet, his back to everything that was happening.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p254"
    }
  }, [_vm._v("Parker raised himself cautiously behind the desk till he could look over the top. His first sight of the room beyond showed him everything as Keegan had described it. No one was looking in this direction. The four clerks were working, Dan Garrison was looking at the money, Beau Lavenstein was looking at his card game, and Hal Pressbury was looking off into space and seemed to be mostly asleep.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p255"
    }
  }, [_vm._v("Parker lifted his right arm and slid it across the desk top to the phone, then pulled the phone toward him. The cord ran off and down the side of the desk, so there was no problem about length. Parker took the phone off the desk top, put it on the floor, sat in front of it, and dialed 9 2 3. Faintly, through the glass and the distant sound of crowd-and-music in the auditorium, he heard the phone ring in the next room.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p256"
    }
  }, [_vm._v("“It’s a clerk,” Keegan said, and the receiver in Parker’s hand clicked. A voice said, “Hello?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p257"
    }
  }, [_vm._v("“A message for Edward Lavenstein,” Parker said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p258"
    }
  }, [_vm._v("“One moment, please.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p259"
    }
  }, [_vm._v("Parker waited. Keegan said, “Here he comes. Garrison’s watching, but he isn’t moving.”")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p260"
    }
  }, [_vm._v("“Hello?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p261"
    }
  }, [_vm._v("“Beau?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p262"
    }
  }, [_vm._v("“Who’s this?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p263"
    }
  }, [_vm._v("“Hold on a second, will you? There’s a message.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p264"
    }
  }, [_vm._v("Parker lowered the phone and put his hand over the mouthpiece. Now, if there was trouble, no one from the next room would be using the phone; the line was tied up till Parker broke the connection at this end.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p265"
    }
  }, [_vm._v("He said, “RG, don’t turn around. I’ve got more instructions for you. When I say to, you go over to the door, open it, and tell Garrison you want to see him. Get him to come in here. Stand to the left of the doorway when he comes in, so he doesn’t see my partner. Talk to him as he’s coming in, keep him distracted, say anything you want. When he’s in, shut the door and say, ‘There are men pointing guns at you. I don’t want anybody killed. I assured them we’d cooperate.’ You got that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p266"
    }
  }, [_vm._v("“I think so.” Nervousness trembled in Stevenson’s voice like a wind riffling curtains.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p267"
    }
  }, [_vm._v("“Tell me what you’re going to say after you shut the door.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p268"
    }
  }, [_vm._v("“There are men here with guns. I don’t want anybody killed. I said we’d cooperate.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p269"
    }
  }, [_vm._v("“Fine. Go ahead now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p270"
    }
  }, [_vm._v("Stevenson turned and walked toward the door. He moved unsteadily, as though he were very tired or a little drunk. Parker, keeping one hand folded over the mouthpiece of the phone, stretched out on his stomach behind the desk, so that his head and shoulders emerged past the desk’s right side and he could see the door Stevenson was walking toward. His left hand, holding the phone receiver, was down at his side. His right hand was out in front of his face, resting the butt of the automatic on the carpet.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p271"
    }
  }, [_vm._v("Stevenson reached the door, and grabbed for the knob as though he needed it to go on standing. He rested his other palm, shoulder-height, against the door frame, then opened the door and called, “Lieutenant Garrison? Could you come here for a moment?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p272"
    }
  }, [_vm._v("Down by Parker’s left hand, a tinny voice said, “Hello? Hello?” A deeper echo sounded through the open door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p273"
    }
  }, [_vm._v("Keegan, his voice low, said, “Here he comes. Easy as pie.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p274"
    }
  }, [_vm._v("Parker saw the feet first, saw Stevenson moving awkwardly to his left—the door opened to the right, making the move slightly cumbersome—heard Stevenson say, “Well, there certainly is a lot of money tonight. A full house, eh? A fitting close for the old building. The new one just won’t seem like home, will it? Here, let me—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p275"
    }
  }, [_vm._v("Garrison had seen neither Keegan nor Parker yet, and was standing in the doorway, waiting for Stevenson to tell him what he wanted. He was about Stevenson’s age, forty-something, but was leaner and harder, with a deeply lined face. Stevenson was trying to reach behind him to shut the door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p276"
    }
  }, [_vm._v("Garrison moved reluctantly, saying, “What is it, Mr. Stevenson?” The voice was carefully neutral, but in its very neutrality, betrayed the contempt Garrison felt. So he was going to be another Dockery, and potentially more trouble.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p277"
    }
  }, [_vm._v("Stevenson, in shutting the door, started to lose his balance because of his nervousness, and had to cling to Garrison’s right arm; that was perfect, and an unexpected bonus. Stevenson said, gasping suddenly, “There are men with guns—Don’t do anything, for the love of God!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p278"
    }
  }, [_vm._v("“What?” Garrison backed into the closed door, trying to push Stevenson away.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p279"
    }
  }, [_vm._v("“Lieutenant Garrison, don’t!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p280"
    }
  }, [_vm._v("Parker called, “It’s okay, Dan!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p281"
    }
  }, [_vm._v("Garrison, confused for a second by the sound of his own first name, stopped struggling with Stevenson and looked around, still seeing no one. “What the hell is this?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p282"
    }
  }, [_vm._v("Parker had the automatic pointed at Garrison’s chest. He called, “RG, back up! Back up to your left.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p283"
    }
  }, [_vm._v("Stevenson hurriedly backed away, babbling as he went: “I don’t want anybody killed! I promised there’d be full cooperation! We’re insured, it’s all right, they’re only after the money—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p284"
    }
  }, [_vm._v("Garrison came a quick step in from the door. His hand was near his holstered revolver, but not quite touching it. He saw Keegan suddenly, and tensed, frowning. Parker said, “Over here, Dan, here’s where the gun is.” Garrison looked quickly toward the voice, and now he saw Parker and the gun. He made no move, but his expression got more grim.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p285"
    }
  }, [_vm._v("Keegan, still watching through the mirror, said, “They’re getting interested.” Meaning one or more of the people in the other room had seen Stevenson’s odd moves and were beginning to wonder.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p286"
    }
  }, [_vm._v("Parker said, “Dan, lie down on your face. Don’t make me shoot your kneecap. I could set off a bomb in here tonight, nobody’d hear it anywhere outside. Get down.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p287"
    }
  }, [_vm._v("“You’re not going to—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p288"
    }
  }, [_vm._v("“We don’t have time, Dan. Down or I shoot, and I mean now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p289"
    }
  }, [_vm._v("Stevenson, backed up against the front of the desk and leaning backward against it for support, cried, “For God’s sake, do it! It isn’t worth getting killed over!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p290"
    }
  }, [_vm._v("“You’ll pay,” Garrison said grimly, and got slowly down onto the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p291"
    }
  }, [_vm._v("Parker lifted the phone up to his ear again. “Beau?”")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p292"
    }
  }, [_vm._v("“Who "), _c('i', [_vm._v("is")]), _vm._v(" this, dammit?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p293"
    }
  }, [_vm._v("Keegan said, “The woman’s talking to him. About the scene in here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p294"
    }
  }, [_vm._v("Parker said, “Beau, I want to tell you Dan Garrison is lying on his face in RG Stevenson’s office, and two men have guns pointed at him. If you do anything hasty or stupid, they’ll kill Dan and then rise up and kill you through the glass. You look at RG now, and he’ll nod to tell you what I’m saying is true. Nod, RG.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p295"
    }
  }, [_vm._v("Parker looked up, and saw Stevenson’s head lower and raise; a mechanical move, as though he were a newly completed robot trying the motion for the first time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p296"
    }
  }, [_vm._v("Keegan said, “Hand over!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p297"
    }
  }, [_vm._v("“Get your hand off the mouthpiece, Beau! Don’t wake Hal up, you’ll just make trouble. Now turn your back to RG’s office. Keep the phone up to your face, and put your other hand on top of your head. Leave it there.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p298"
    }
  }, [_vm._v("Keegan said, “He’s done it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p299"
    }
  }, [_vm._v("Keeping an eye on Garrison, who was prone with his head arched up so he could see what was going on, Parker got his feet under him and stood. “Move to the left, RG,” he said, and when Stevenson moved leftward, Parker had an unobstructed view of the room.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p300"
    }
  }, [_vm._v("Everybody in there knew by now that something was wrong. Pressbury—a man about Dockery’s age, but more gone to seed—was on his feet now and walking toward Lavenstein, a worried frown on his face. The three male clerks were all still at their desks, but none of them were working. All were looking at Lavenstein, who was facing them and not saying anything. The woman clerk—hers was the front desk, the one with the phone—was standing beside Lavenstein, looking this way. Parker saw her see him and clutch at Lavenstein’s side; in the earpiece \n\n"), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _vm._v("\nof the phone he could faintly hear her saying something to Lavenstein and then Lavenstein’s irritable voice, loud and clear, saying, “I know, I know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p301"
    }
  }, [_vm._v("To Keegan, Parker said, “Take Dan.” Into the phone he said, “Beau, tell Hal to stand where he is. Go on, tell him.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p302"
    }
  }, [_vm._v("“Stop there, Hal. They’ve got guns on us, stop there.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p303"
    }
  }, [_vm._v("“Tell him to put his hands on his head.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p304"
    }
  }, [_vm._v("“They say to put your hands on your head. Better do it, I guess.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p305"
    }
  }, [_vm._v("“Tell him to turn left.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p306"
    }
  }, [_vm._v("“They say turn left.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p307"
    }
  }, [_vm._v("“Tell him to back up until he’s against the door.” Which would be the nearer door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p308"
    }
  }, [_vm._v("“They say you should back up against the door.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p309"
    }
  }, [_vm._v("“Tell the clerks to go over and sit on the sofa. The woman, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p310"
    }
  }, [_vm._v("“They want you people to go sit on the sofa.” The woman’s voice yammered; her expression through the glass was outraged. “You, too, Mrs. Kimberly. Yeah, but you better do it. They’ve got the upper hand now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p311"
    }
  }, [_vm._v("Keegan said, “He’s de-fused.” He got to his feet with his own gun in his right hand and Garrison’s revolver in his left. “Only the one gun on him.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p312"
    }
  }, [_vm._v("The male clerks were all moving toward the sofa, the woman last and with the most reluctance. At the sofa, one of the male clerks suddenly bolted for the other door. The people around him all looked startled. He yanked the door open and dashed outside.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p313"
    }
  }, [_vm._v("Keegan calmly opened the door between the rooms and headed down the window side of the room to cover everybody from the other end.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p314"
    }
  }, [_vm._v("The clerk who’d made a dash for it backed into the room, hands over his head. In response to an order, he lowered one hand and shut the door. Keegan said something to him, and he sat down on the sofa. The others all joined him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p315"
    }
  }, [_vm._v("Parker said, “RG, go next door and stand against the wall between Hal and the others.” He waited till Stevenson was in position, then said, “Okay, Dan, you can get up now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p316"
    }
  }, [_vm._v("Garrison got to his feet. He looked grim and angry. He stared at Parker and seemed to consider saying something, but just shook his head.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p317"
    }
  }, [_vm._v("Parker said, “Go next door, Dan, and stand to this side of Hal.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p318"
    }
  }, [_vm._v("Parker followed Garrison through and went over behind Lavenstein to take the revolver out of his holster and put it in his own hip pocket. Then he said, “Hang up the phone, Beau. Go over and stand with your back to the door your friend ran out of.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p319"
    }
  }, [_vm._v("Keegan was down at the other end, back to the filing cabinets, automatic pointed in the general direction of the people along the side wall.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p320"
    }
  }, [_vm._v("Parker walked over to Hal Pressbury, who was looking cranky and crotchety, and who said, “You people can’t get away with this sort of thing. You think this is the Wild West?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p321"
    }
  }, [_vm._v("“Turn around, Hal.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p322"
    }
  }, [_vm._v("“So you can shoot me in the back? You’ll have to look me in the eye, you son of a bitch.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p323"
    }
  }, [_vm._v("“Hal, you either turn around so I can disarm you, or I’ll have to knock you out.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p324"
    }
  }, [_vm._v("“I’ll meet you face to face.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p325"
    }
  }, [_vm._v("Parker put the automatic in his left hand, raised his \n\n"), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _vm._v("\nright fist in front of his shoulder, and punched Pressbury between the eyes. Pressbury’s head snapped back, bouncing off the door, and his face went slack. With a hand to his chest, Parker kept him from falling forward and let him slide down the door to a sitting position. Then he took Pressbury’s revolver, patted him briefly to be sure he had no other weapons, and backed away from him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p326"
    }
  }, [_vm._v("Garrison said tightly, “That’s something else you’ll pay for.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p327"
    }
  }, [_vm._v("“We may pay later,” Parker said, turning his head back and forth so they’d know he was talking to all of them, “but any one of you people who disobeys us will pay now.” He walked over to the sofa, keeping the automatic in his left hand, and stood in front of the clerk who’d tried ducking out the door. “Stand up,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p328"
    }
  }, [_vm._v("The clerk was afraid now. “What do you want from me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p329"
    }
  }, [_vm._v("“You’ve disobeyed once. Don’t make it twice. Stand up.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p330"
    }
  }, [_vm._v("The woman, sitting beside him, said, “You’d better do what he says, George.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p331"
    }
  }, [_vm._v("George, blinking, trying to fit an expression of bravado onto his face, leaned forward to get up and Parker hit him on the nose. George bounced back into the sofa, and Parker waited to see if his nose would start bleeding. The woman said something shocked and angry, everybody stirred, and George put his hand to his face. When he took it away to look at it, his fingertips were red; a drop of blood hit his shirt.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p332"
    }
  }, [_vm._v("The woman said, “Oh, you’re bleeding!” and started busily to reach into her sleeve.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p333"
    }
  }, [_vm._v("Parker said, “Nobody touches him. He doesn’t use a handkerchief or a tissue or any cloth. George? You can \n\n"), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _vm._v("\nput your head back, but keep your hands away from your face.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p334"
    }
  }, [_vm._v("The woman said, “You people are inhuman!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p335"
    }
  }, [_vm._v("“Then you should be very cautious with us,” Parker said. He turned his back on them all and went over to the nearest desk, where he put down the automatic and took the two guards’ guns from his hip pockets. Behind him, he knew they were all watching George, who was in a position none of them would want to be in for himself; not dangerous, but uncomfortable and humiliating. Head back, blood dribbling from his nose, having to gulp and gasp when he breathed. Nobody else would want to wind up like that, so the others would be less likely now to try something stupid.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p336"
    }
  }, [_vm._v("Keegan kept them all covered. Originally, of course, Berridge would have been the man outside, and Keegan and Briley would both have watched the prisoners, one at either end of the room. There was more menace implicit in being unable to look at all the guns facing you at the same time. But Parker had been making up for that in other ways.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p337"
    }
  }, [_vm._v("Now he took the blue laundry bag from his pocket, ripped open the outer plastic—it was the toughest thing to do so far, with the work gloves on—and then shook open the bag. He swept all the loose unbanded bills from the desk into the bag, and next emptied the banded stacks of bills from the trays beside the desk. The second desk filled the bag, and he took a rubber band from his side trouser pocket and closed the neck of the bag. Then he carried the bag, which was pretty heavy now, into Stevenson’s office and left it beside the hall door. He picked up the toolkit, carried it into the room, and put it on the first desk, beside the phone. This one was hung up, but the one on Stevenson’s \n\n"), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _vm._v("\ndesk was still off the hook, so a call to either of these numbers would produce a busy signal.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p338"
    }
  }, [_vm._v("Keegan had the second blue bag. He tossed it to Parker, who opened it and filled it with the bills at the third and fourth desks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p339"
    }
  }, [_vm._v("Now there was a minor error in the routine, the result of the last-minute change from Berridge. Briley had the third laundry bag, and was in the hall; when they’d made the switch of assignments, nobody’d thought to change that one detail. Which was why normally Parker preferred to let a job go rather than make late changes in the pattern. This time the problems hadn’t seemed very large, and the job itself was tempting, so he’d relaxed a rule for himself. With any luck, this business with the laundry bag was the only place a seam would show.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p340"
    }
  }, [_vm._v("Parker closed the top of the second bag with another rubber band and carried it in to put it beside the first. Then he opened the hall door, and Briley spun at once and showed him Dockery’s revolver; then he grinned and put the revolver away again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p341"
    }
  }, [_vm._v("The music noise was louder out here. Parker called, “The laundry bag.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p342"
    }
  }, [_vm._v("“By God, you’re right. It’s in my jacket, in the john.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p343"
    }
  }, [_vm._v("“Get it. There’s room for your clothes in it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p344"
    }
  }, [_vm._v("“Good,” Briley said, and hurried off toward the men’s room.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p345"
    }
  }, [_vm._v("Parker stayed in the doorway, watching both ways. This was where a small seam could become a big tear that would rip the whole job open. If someone came up here while Briley was around, Briley could act officious and send him on his way. If someone came up now, it would be a complication. They were dependent on luck, for good \n\n"), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }), _vm._v("\nor ill, and that was no way to set things up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p346"
    }
  }, [_vm._v("Should he have let it go with just the two bags’ worth? They had the money from all the desks, but not the unsorted money in the canvas bags still on the table. To leave that behind would be a failure in a different direction; the job had a seam in it, that was all.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p347"
    }
  }, [_vm._v("Briley came back with the third bag, open and already with contents. It had been planned all along to include the substitute guard’s clothing in one of the bags with the money, if there was room. If not, the guard would either have made a quick change on the roof, having carried his own clothing that far, or waited till they were back in the theater.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p348"
    }
  }, [_vm._v("Briley handed over the bag and said, “You should have seen that boy when he came out the door and I throwed down on him. I wish I’d had a camera.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p349"
    }
  }, [_vm._v("“We’ll be out in five minutes,” Parker said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p350"
    }
  }, [_vm._v("“Take your time. I’m getting so I like this music.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p351"
    }
  }, [_vm._v("Parker shut the door and went back to finish stacking the money. The third bag wasn’t quite as full as the other two, even with Briley’s clothes in the bottom. Parker put it with the others, went back to the main room, and said, “You people on the sofa, get up.” Pressbury was standing again now, and looking mulish but not dangerous. Parker said, to the four clerks, “Turn around and face the sofa. Beau, come over and stand at the end of the line. Hal, come up to the other end. RG, stand beside Hal. Dan, you stand beside RG.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p352"
    }
  }, [_vm._v("The eight people stood in a row, facing the wall. Parker took the sets of handcuffs from the toolkit, started with Garrison, and handcuffed them all together, finished with Beau Lavenstein at the other end, and had one set of \n\n"), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }), _vm._v("\ncuffs left. He said, “Everybody turn right. We’re going into the corner over there.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p353"
    }
  }, [_vm._v("It was the far corner of the exterior wall, between the windows and the filing cabinets. One of the marks of this building’s age was the heat pipes that ran up beside the walls in the corners of all the rooms. Parker now arranged the eight people so that Lavenstein was just to the left of this pipe, facing the filing cabinet, the others made a circle, all facing outward, and Garrison, the other end of the line, was just to the right of the pipe, facing toward the windows. Parker cuffed Garrison’s and Lavenstein’s free hands together, with the cuff chain running behind the pipe. Now they were all limited to the corner of the room, where they couldn’t reach the phone or a door or a window, and were in a circle facing outward so that even communication with one another would be difficult.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p354"
    }
  }, [_vm._v("Parker and Keegan put all the guns in the toolkit, and Keegan carried it when they went into Stevenson’s office. Parker left Stevenson’s phone off the hook—it was still better for a caller to get a busy signal than no answer—and opened the door to put all three laundry bags outside. Keegan went out, carrying the toolkit, and Parker followed him and shut the door. Now Parker carried two of the laundry bags, and Keegan one laundry bag and the toolkit, and they followed Briley down the hall and up the stairwell, Briley checking things out at every stage of the trip.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p355"
    }
  }, [_vm._v("It went without trouble. The music still pounded away down there, the audience was even louder than before, and it was likely the show would run over the minimum length. Still it was not quite ten minutes to two, their deadline, and they were well on their way.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p356"
    }
  }, [_vm._v("The upstairs office was as they’d left it. Briley ran up the furniture staircase, and Keegan and Parker handed up the three laundry bags and two toolkits. They’d turned the light on when entering the room, and Parker turned it out again after Keegan and Briley were both out and up on the roof. Then he followed them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p357"
    }
  }, [_vm._v("Morris had come over from the fire escape. “Not a bit of trouble,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p358"
    }
  }, [_vm._v("“Nor us,” Briley said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p359"
    }
  }, [_vm._v("“Here’s something,” Keegan said. He was still finding things to be disgusted about. “That lousy Berridge has us loused up. We’ve got five things to carry and now there’s only four of us.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p360"
    }
  }, [_vm._v("Morris said, “I’ll carry two. I’ve had a nice long rest. I’ll carry the money.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p361"
    }
  }, [_vm._v("Morris went first, carrying two of the laundry bags. Briley followed, with the bag containing his own clothes, followed by Keegan and Parker, each with a toolkit, Parker carrying the kit that had been left upstairs, the one with the snaps on the outside for carrying the ax.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p362"
    }
  }, [_vm._v("It was strange not to hear the music. Going down the fire escape, they heard the sounds of the city instead; few sounds at this hour, mostly traffic.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p363"
    }
  }, [_vm._v("The Strand Theater’s fire door looked the same as usual, but was different in that it had been unlocked from the inside. Grasping the lip overhang at the bottom, it was possible to pull the door open.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p364"
    }
  }, [_vm._v("Keegan had the flashlight, and didn’t turn it on until they were all in the theater and Parker had closed and relocked the door. Then the light shone out across the cluttered empty stage—this had been a vaudeville theater long ago, when it was first built and movies weren’t important yet—and they picked their way slowly through the \n\n"), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }), _vm._v("\nrubble; the screen, sound system, and some other things had already been stripped out of this building.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p365"
    }
  }, [_vm._v("The third toolkit and the "), _c('i', [_vm._v("Union Electric Co.")]), _vm._v(" coveralls were where they’d left them, in seats near the back of the theater. Briley scaled the guard’s hat through the darkness toward the stage, and they all took off their masks and put on the coveralls. Keegan had put the flashlight on an armrest at the end of an aisle, pointing its light toward the stage, and their movements in front of it as they put on the coveralls made bat-shadows fly all over the high empty interior of the building.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p366"
    }
  }, [_vm._v("Morris went first, carrying a toolkit out to the truck, waiting for them in front of the marquee. They heard him start the truck engine, and then the rest of them came out, carrying things, Parker and Keegan making two trips. The street was almost deserted, only two cars going by in the time it took them to load the truck. Parker sat up front beside Morris, Keegan and Briley sat in back on the bags of money, and Morris drove them away from there.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p367"
    }
  }, [_vm._v("The first time they were stopped at a traffic light, Morris said, “Any trouble in there?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p368"
    }
  }, [_vm._v("“No. It went the way it was supposed to.” He thought about the laundry bag in the wrong place, and being short one man to carry things away from there, but they were points too minor to mention.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p369"
    }
  }, [_vm._v("“Sounded like nice music.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p370"
    }
  }, [_vm._v("Parker had nothing to say to that. The light turned green, and they drove on.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p371"
    }
  }, [_vm._v("The house they were heading for, Keegan had rented two weeks ago, though none of them had been there since, until they’d left their cars in the neighborhood and suitcases in the house earlier today. It had taken Keegan \n\n"), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }), _vm._v("\nfour full days to find a house that suited their needs, and this one had checked out right down the list. In the first place, it was owned by a realty corporation rather than an individual, which meant that so long as the rent was paid, no one would be dropping by to chat with the tenant. Second, its neighbors on both sides were commercial concerns that closed in the evening—a supermarket on one side, a hobby shop on the other. It had a garage and a good-sized backyard, all enclosed by a high board fence. It had come furnished, including a phone, so no one would be wondering why the house was standing empty, particularly since Keegan, the day he took the place, had set time switches that turned lamps on at six P.M. every day in the living room and one of the upstairs bedrooms, and switched them off again a little past midnight.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p372"
    }
  }, [_vm._v("It was called Dornwell Street, and the house number was 426. When Morris drove the "), _c('i', [_vm._v("Union Electric Co.")]), _vm._v(" truck down Dornwell Street now, it was silent and dark and empty, the buildings black on both sides, the only illumination coming from wide-spaced streetlights. Morris turned into the driveway at 426, cut the headlights, and came to a stop. Keegan climbed out of the back of the truck and trotted up to open the garage door, a segmented aluminum door that slid upward. Morris drove the truck into the garage, and then all four of them carried everything into the house, turning on a small worklight over the stove in the kitchen, until they had themselves and everything else inside. Then they switched on the round fluorescent light in the middle of the ceiling.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p373"
    }
  }, [_vm._v("Keegan had stocked the place with food this morning, and now he and Morris stayed in the kitchen to broil some steaks while Briley and Parker carried the blue plastic laundry bags into the dining room.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p374"
    }
  }, [_vm._v("The dining room had no windows, and the wide entryway to the living room could be closed by sliding doors recessed into the walls. They closed these doors now, and then switched on the overhead light fixture and emptied the first of the laundry bags onto the dining-room table. They’d chosen the bag with Briley’s clothes in it first, and Briley went away to change while Parker sat at the table and began the split.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p375"
    }
  }, [_vm._v("They would stay here two or three days, depending on what the radio told them about the local law activity. The cars they had parked around the neighborhood were all clean, and shouldn’t attract any attention.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p376"
    }
  }, [_vm._v("Briley came to the side doorway, which they’d left open because it didn’t expose them to any windows. He said, “Parker.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p377"
    }
  }, [_vm._v("“What is it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p378"
    }
  }, [_vm._v("“You better come take a look.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p379"
    }
  }, [_vm._v("Parker got up from the table and went with him. The hall led to the front door at one end and the kitchen at the other, with the living and dining rooms opening off it along the way. The staircase was across the hall from the living room, with the bathroom between it and the kitchen. Briley, still in his coveralls, his clothes still over his arm, led the way to the bathroom and stood aside for Parker to go in. He’d already turned the light on.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p380"
    }
  }, [_vm._v("Berridge was lying on his back on the floor. The side of his head had been punched in, and a plumber’s wrench with the end bloody and hair-matted was lying on the floor between the body and the toilet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "part_p381"
    }
  }, [_vm._v("They searched the house and it was empty.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14fb356a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/part01.vue
// module id = 78
// module chunks = 0